import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBank: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBank"><Path d="M12 2L2.5 7.5V9.5H21.5V7.5L12 2Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 20.5H2.5L3.5 17.5H20.5L21.5 20.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 9.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 17.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 9.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 17.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBank;
